
//@ts-check
import * as d3 from "d3";

/**
 * @module Utilities
 */

/**
 * Exits in Array while loop when matched the target Element
 * @param {*} arr - Array
 * @param {*} targetElem - Target Element
 * @returns {boolean} returns true or false
 */
export function existsInArrayWhile(arr, targetElem) {
  let i = 0
  while (i < arr.length) {
    if (arr[i] === targetElem) return true
    i++
  }
  return false
}

/**
 * Converts Canvas to Svg String
 * @returns {Object} 
 */
export function toSvgString() {
  let scope = this;

  return d3.select(scope.canvas).select('svg').node().parentNode.innerHTML;
}

/**
 * Set Digits 
 * @param {Number} value - Value
 * @returns {Number} 
 */
export function setDigits(value) {
  const factor = Math.pow(10, this.digits);
  let val = value;
  if (!isNaN(value)) val = Math.round(value * factor) / factor;
  return val;
}